const doc = [({"da":({"js":({"admin":({"photo_sheet_products":({"select":({"choose_photo_sheet_product":"Vælg fotoarkprodukt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;